import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://5b73a3842c664d4dbb68f73fc88c8f7d@o4508561309892608.ingest.us.sentry.io/4509944721637381",
  // Error + performance tracing only. Session Replay was removed because its
  // bundle weight hurt the mobile PageSpeed score more than it helped debugging.
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  enableLogs: true,
});
